import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import Interaction from "../../../models/interactions/Interaction";
import { useStoreDispatch, useStoreSelector } from "../../../store/Hooks";
import { navSliceActions } from "../../../store/slices/NavSlice";
import Tooltip from "@material-ui/core/Tooltip";

interface InteractionEditButtonProps {
  interaction: Interaction;
  disabled?:boolean
}

const InteractionEditButton = (props: InteractionEditButtonProps) => {
  const rightDrawerOpen = useStoreSelector(
    (state) => state.nav.rightDrawerOpen,
  );

  const dispatch = useStoreDispatch();

  function handleOpenEdit() {
    dispatch(
      navSliceActions.openRightDrawer({
        content: props.interaction,
        type: "interactions",
      }),
    );
  }

  return (
    <Tooltip title="Edit Interaction">
      <IconButton disabled={props.disabled || rightDrawerOpen} onClick={handleOpenEdit}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
};

export default InteractionEditButton;
